export const NAVBAR_OPTIONS = [
  { label: "Day", value: "DAY" },
  { label: "Week", value: "WEEK" },
];
